import { memo } from "react";

function TrailerDropStopMarker(props) {
  const shiftLeft = props.stopNo && props.stopNo < 10 ? 0 : -3;
  return (
    <svg
      width={props.dimension}
      height={props.dimension}
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Stops-on-map-" transform="translate(1.000000, 1.000000)">
        <circle
          id="Oval-15"
          stroke={props.border}
          fill={props.backgroundColor}
          cx={22}
          cy={6}
          r={6}
        />
        <g transform="translate(1.000000, 1.000000)">
          <text
            id={1}
            fontFamily="OpenSans-SemiBold, Open Sans"
            fontSize={8}
            fontWeight={500}
            fill={props.textColor}
          >
            <tspan x={19 + shiftLeft} y={8}>
              {props.stopNo}
            </tspan>
          </text>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7125 8.50055C14.9586 12.1358 17.8642 15.0414 21.4995 15.2875C21.8245 16.3 22 17.3795 22 18.5C22 24.299 17.299 29 11.5 29C5.70101 29 1 24.299 1 18.5C1 12.701 5.70101 8 11.5 8C12.6205 8 13.7 8.17551 14.7125 8.50055Z"
        fill={props.backgroundColor}
        stroke={props.border}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70097 13.851C7.56613 13.851 6.64508 14.772 6.64508 15.9068C6.64508 17.0417 7.56613 17.9627 8.70097 17.9627C9.83585 17.9627 10.7569 17.0417 10.7569 15.9068C10.7569 14.772 9.83585 13.851 8.70097 13.851ZM9.7289 16.1124H7.67301V15.7013H9.7289V16.1124Z"
        fill={props.border}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1002 16.0257C11.1002 16.0673 11.0992 16.1087 11.097 16.1498H14.0068V20.5978H10.5849C10.3336 20.3864 10.0093 20.2591 9.65524 20.2591C9.30121 20.2591 8.97691 20.3864 8.72563 20.5978H8.11388V18.286C7.77571 18.1907 7.46853 18.0216 7.21075 17.7971V21.5009H8.22443C8.21506 21.5673 8.21023 21.6351 8.21023 21.7041C8.21023 22.5021 8.8572 23.1491 9.65524 23.1491C10.4533 23.1491 11.1002 22.5021 11.1002 21.7041C11.1002 21.6351 11.0954 21.5673 11.0861 21.5009H16.3549V20.5978H14.9099V15.2467H10.968C11.0537 15.4905 11.1002 15.7526 11.1002 16.0257ZM10.1547 21.5009C10.0745 21.3039 9.88107 21.165 9.65524 21.165C9.42943 21.165 9.23603 21.3039 9.15579 21.5009C9.13023 21.5636 9.11614 21.6322 9.11614 21.7041C9.11614 22.0018 9.35754 22.2431 9.65524 22.2431C9.95296 22.2431 10.1943 22.0018 10.1943 21.7041C10.1943 21.6322 10.1803 21.5636 10.1547 21.5009Z"
        fill={props.border}
      />
    </svg>
  );
}

export default memo(TrailerDropStopMarker);
